import './NavBar.css'
import NavLinks from './NavLinks'

const Navigation = () => {
    return (
        <nav className="Navigation"> 
            <NavLinks/>
        </nav>
      );    
}
export default Navigation;